module.exports = __webpack_public_path__ + "static/media/59.dfdc5cf6.jpg";